import * as React from 'react';
import { FC } from 'react';

export const Home: FC = () => {

    return (
        <div>Home</div>
    );
}
